import { styled } from '@mui/material/styles';
import { COLORS } from '../../../../utils/colors';
import { Box, Button, Modal, Typography } from '@mui/material';

export const useFormStyles = () => {
  return {
    select: {
      width: '100%',
      borderRadius: '0.5rem',
      '& .MuiOutlinedInput-root': {
        padding: '.5rem',
      },
    },
    inputLabel: {
      fontSize: '1rem',
      backgroundColor: 'white',
      px: '.5rem',
    },
    formData: {
      border: `.0625rem solid ${COLORS.MEDIUM_GRAY}`,
      borderRadius: '.25rem',
      p: 0,
      height: 'calc(100% - 29.5rem)',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'auto',
    },
    buttonContainer: {
      mt: '1.25rem',
      display: 'flex',
      gap: '1rem',
      justifyContent: 'flex-end',
      position: 'absolute',
      bottom: '0',
      right: '0',
      width: '100%',
      backgroundColor: 'white',
      padding: '1.25rem',
      borderTop: `1px solid ${COLORS.MEDIUM_GRAY}`,
    },
    shareWithOrganization: {
      display: 'flex',
      alignItems: 'center',
      marginRight: 'auto',
    },
    documentLoading: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: 'calc(100% - 29.5rem)',
    },
    invalidFormData: {
      color: 'red',
      fontStyle: 'italic',
      float: 'right',
      ml: 'auto',
    },
    pre: {
      padding: '0',
      margin: '.5rem 0',
      whiteSpace: 'pre-wrap',
      wordBreak: 'break-word',
      flexGrow: 1,
      overflowY: 'auto',
      '& .MuiInputBase-root': {
        height: '100%',
        fontFamily: 'monospace',
        fontSize: '0.875rem',
        alignItems: 'flex-start',
        padding: '0',
        margin: 0,
      },
      '& .MuiOutlinedInput-notchedOutline': {
        border: 'none',
      },
    },
    validFormData: {
      color: '#888',
      fontStyle: 'italic',
      paddingLeft: '1rem',
    },
    previewModal: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '80%',
      height: '90vh',
      bgcolor: 'background.paper',
      boxShadow: 24,
      p: 0,
    },
    formEditor: {
      p: '1rem',
      overflow: 'auto',
      height: 'calc(100% - 29.5rem)',
    },
    childBox: {
      mb: '4rem',
      pl: '1rem',
      borderLeft: '2px solid #ccc',
      position: 'relative',
    },
    itemBox: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',
      mb: '2rem',
      pl: '1rem',
      borderLeft: '2px solid #0c0',
    },
    addItemButton: {
      position: 'absolute',
      right: '1rem',
      bottom: '-2.5rem',
    },
    typeBox: {
      display: 'flex',
      alignItems: 'center',
      gap: 2,
      width: '100%',
    },
  };
};

export const StyledModal = styled(Box)({
  position: 'absolute',
  top: '3.625rem',
  right: 0,
  height: 'min(calc(100vh - 4rem), 60rem)',
  width: '55%',
  backgroundColor: COLORS.WHITE,
  boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.26)',
  padding: '1.125rem 1.4375rem',
});
